
import Vue from 'vue'
import {Component, Prop, Model, Watch} from 'vue-property-decorator'
import {Action, Getter, namespace} from 'vuex-class'

const groupeModule = namespace('groupe')

@Component
export default class SelectGroupe extends Vue {
  @Prop(String) placeholder!: string
  @Prop() value!: any
  @Prop() afterOption!: any

  @groupeModule.Action('getGroupesAction') getGroupes: any
  @groupeModule.Getter('groupesGetter') groupes: any

  get options() {
    return this.groupes || []
  }

  get selected() {
    return this.value
  }

  set selected(v) {
    this.$emit('input', v)
  }

  mounted() {
    if (!this.groupes) this.getGroupes()
  }
}
